import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AutofocusModule } from '®shared/autofocus';
import { EventsService } from '®shared/events';
import { ReportBrokenLinkEventsEffects } from '®shared/events/report-broken-link-events.effects';
import { TarlV3ApiModule } from '®shared/tarl-v3-api';
import { TrapFocusModule } from '®shared/trap-focus';

import { ReportBrokenLinkModalComponent } from './report-broken-link-modal.component';
import { ReportBrokenLinkEffects } from './report-broken-link.effects';
import { reportBrokenLinkReducer } from './report-broken-link.reducer';
import { ReportBrokenLinkService } from './report-broken-link.service';
import {
  STATE_FEATURE_REPORT_BROKEN_LINK,
  getInitialReportBrokenLinkState,
} from './report-broken-link.state';

@NgModule({
  declarations: [ReportBrokenLinkModalComponent],
  imports: [
    AutofocusModule,
    CommonModule,
    EffectsModule.forFeature([
      ReportBrokenLinkEffects,
      ReportBrokenLinkEventsEffects,
    ]),
    ModalModule,
    ReactiveFormsModule,
    TarlV3ApiModule,
    TrapFocusModule,
    StoreModule.forFeature(
      STATE_FEATURE_REPORT_BROKEN_LINK,
      reportBrokenLinkReducer,
      {
        initialState: getInitialReportBrokenLinkState,
      },
    ),
  ],
  exports: [ReportBrokenLinkModalComponent],
  providers: [ReportBrokenLinkService, EventsService],
})
export class ReportBrokenLinkModalModule {}
